import React, { useState } from 'react';
import Link from 'next/link';
import Icon from '@common/assets';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useApplyTutorial } from '@components/acca/test/query/useApply';
import { useTermsCheckNewMutation } from '@components/acca/test/query/useTerms';
import AccaModal from '@components/acca/test/modals';
import Colors from '@domain/constant/colors';
import { AccaModalType } from '@domain/constant/acca/AccaModalType';
import { TERMS } from '@domain/constant/termsType';
import { V2Route } from '@utils/routeUtil';

import UrlUtil from '@utils/urlUtil';
import classnames from 'classnames/bind';
import styles from './gateCard.module.scss';
const cx = classnames.bind(styles);

interface GateListProps {
  thumbnail: string;
  number: number;
  title: string;
  list1: string;
  list2: string;
  list3: string;
  link: string;
  button: string;
  typeTutorial?: boolean;
}

const GateCard = ({ thumbnail, number, title, list1, list2, list3, link, button, typeTutorial }: GateListProps) => {
  const [modalState, setModalState] = useState<AccaModalType>(null);
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { data: tutorialApplyData } = useApplyTutorial(isLogin);
  const { mutateAsync: checkTermsMutateAsync } = useTermsCheckNewMutation();

  // 튜토리얼 페이지 열기
  const onApplyTutorial = async () => {
    const { url, token } = tutorialApplyData;
    const accTutorialUrl = V2Route.getAccaTutorialPage(url);
    UrlUtil.openWindowWithPost(accTutorialUrl, { Authorization: `Bearer ${token}` });
  };

  const onClickTutorialApplyBtn = async () => {
    if (!isLogin) {
      setModalState('LOGIN');
      return;
    }

    // 약관 동의 여부 체크
    const { existsNewTermsAgree } = await checkTermsMutateAsync(TERMS.ACC_TRIAL_PRIVACY_POLICY);
    if (existsNewTermsAgree) {
      setModalState('TUTORIAL_TERMS');
      return;
    }

    onApplyTutorial();
  };

  return (
    <div className={cx('gateInner')}>
      <div className={cx('thumbnail')} style={{ backgroundImage: `url(${thumbnail})` }} />
      <div className={cx('listInner')}>
        <div className={cx('titleInner')}>
          <span className={cx('number')}>{number}</span>
          <span className={cx('title')}>{title}</span>
        </div>
        <ul>
          <li className={cx('list')}>
            <Icon name="checkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
            {list1}
          </li>
          <li className={cx('list')}>
            <Icon name="checkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
            {list2}
          </li>
          <li className={cx('list')}>
            <Icon name="checkLight" width={24} height={24} fill={Colors.C_COOL_GRAY_70} />
            {list3}
          </li>
        </ul>
        {typeTutorial ? (
          // 튜토리얼인 경우 노출
          <a className={cx('link', 'acca_intro_gateLink')} role="button" onClick={onClickTutorialApplyBtn}>
            {button}
          </a>
        ) : (
          <Link href={link} legacyBehavior>
            <a className={cx('link', 'acca_intro_gateLink')} role="button" target="_blank">
              {button}
            </a>
          </Link>
        )}
      </div>

      <AccaModal modalState={modalState} setModalState={setModalState} />
    </div>
  );
};

export default GateCard;
